import React from 'react'
import { Card, Col } from 'react-bootstrap'
import iconexplore from '../Assets/explore.svg'
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarR } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SingleCard {
  variant: any;
  data: any;
  fav?: boolean
}
const SingleCard: React.FC<SingleCard> = ({ variant, data, fav = true }) => {
  return (
    <>
      {variant == 1 && <Card className='card-app'>

        <Card.Img />
        <Card.Body className='bg-9'>
          <Card.Title>{data.app_name}</Card.Title>
          <Card.Text>
            {data.app_description}
          </Card.Text>
        </Card.Body>
        <Card.Footer className="text-muted d-flex justify-content-between align-items-center bg-white">
          <p>{data.location}</p>
          {fav && <FontAwesomeIcon icon={faStar} size="lg" />}

        </Card.Footer>
      </Card>}
      {variant == 2 && <Card className='bg-4 p-3 card-app card  d-flex justify-content-center align-items-center'>

        <Card.Img src={iconexplore} alt="Card image" className='img-fluid' />

      </Card>}
    </>

  )
}

export default SingleCard